import './applicationCardStyle.css'
import ReadMoreButton from "../../../../../components/buttons/readMoreButton/readMoreButton";
import H3Title from './../../../../../components/text/h3Title/h3Title'
import NormalText from './../../../../../components/text/normalText'

export default function ApplicationCard({application}) {
    return (
        <article className='application__content'>
            <H3Title title={application.title} />
            <NormalText text={application.text} />
            <ReadMoreButton url={"/applications"}/>
        </article>
    );
}